import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { scrollBody, actionBtn, ProgressHeader, WebEntryLayout } from './entryHelpers';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

const labelStyle: React.CSSProperties = {
  fontSize: 9,
  fontWeight: 600,
  color: T.textTer,
  fontFamily: T.font,
  marginBottom: 4,
};

const fieldStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 14px',
  borderRadius: 10,
  border: `1px solid ${T.border}`,
  background: T.ice,
  fontSize: 12,
  fontFamily: T.font,
  color: T.text,
  outline: 'none',
  boxSizing: 'border-box',
};

export default function PatRegContactScreen() {
  const navigate = useNavigate();
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [pin, setPin] = useState('');

  return (
    <WebEntryLayout>
    <div style={{ flex: 1, background: T.white, display: 'flex', flexDirection: 'column', fontFamily: T.font }}>
      <ProgressHeader title="Contact & Address" step={2} total={8} onBack={() => navigate(-1)} />

      <div style={scrollBody}>
        {/* Address Line 1 */}
        <div>
          <div style={labelStyle}>Address Line 1</div>
          <input
            type="text"
            placeholder="House/Flat No., Street"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            style={fieldStyle}
          />
        </div>

        {/* City */}
        <div>
          <div style={labelStyle}>City</div>
          <input
            type="text"
            placeholder="Enter city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            style={fieldStyle}
          />
        </div>

        {/* State */}
        <div>
          <div style={labelStyle}>State</div>
          <input
            type="text"
            placeholder="Enter state"
            value={state}
            onChange={(e) => setState(e.target.value)}
            style={fieldStyle}
          />
        </div>

        {/* PIN Code */}
        <div>
          <div style={labelStyle}>PIN Code</div>
          <input
            type="text"
            inputMode="numeric"
            placeholder="6-digit PIN code"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            style={fieldStyle}
          />
        </div>

        {/* Next Button */}
        <button
          onClick={() => {
            patientAuthFlow.completeAddress({ address, city, state, pin });
            navigate('/patient/register/otp');
          }}
          style={{
            ...actionBtn('Next', T.teal, T.white),
            width: '100%',
            padding: 13,
            borderRadius: 12,
            fontSize: 13,
          }}
        >
          Next
        </button>
      </div>
    </div>
    </WebEntryLayout>
  );
}
